import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//Components
import ErrorSuccessModal from './ErrorSuccessModal';

// Helpers
import actions from '../../actions/FavoritesActions';
import { copy, mutations } from '../../constants';

const ErrorSuccessContainer = ({
    mutationResponse,
    openModalType,
    setModalOpen,
    setMutationResponse,
    modalOpen,
}) => {
    if (mutationResponse === mutations.responses.LOADING) {
        return null;
    }

    const onClose = () => {
        setMutationResponse(mutations.responses.COMPLETE);
        setModalOpen(false);
    };

    const description = openModalType
        ? copy[openModalType][`${mutationResponse.toUpperCase()}_DESCRIPTION`]
        : '';
    const title = openModalType
        ? copy[openModalType][`${mutationResponse.toUpperCase()}_TITLE`]
        : '';
    return (
        <ErrorSuccessModal
            description={description}
            onClose={onClose}
            isOpen={modalOpen}
            title={title}
            type={mutationResponse}
        />
    );
};

ErrorSuccessContainer.propTypes = {
    mutationResponse: PropTypes.string,
    openModalType: PropTypes.string,
    modalOpen: PropTypes.bool,
    setModalOpen: PropTypes.func,
    setMutationResponse: PropTypes.func,
    setOpenModalType: PropTypes.func,
};

const mapDispatchToProps = dispatch => {
    return {
        setModalOpen: modalOpen => {
            dispatch(actions.setModalOpen({ modalOpen }));
        },
        setMutationResponse: mutationResponse => {
            dispatch(actions.setMutationResponse({ mutationResponse }));
        },
        setOpenModalType: openModalType => {
            dispatch(actions.setOpenModalType({ openModalType }));
        },
        setShowErrorSuccessModal: showErrorSuccessModal => {
            dispatch(actions.setShowErrorSuccessModal({ showErrorSuccessModal }));
        },
    };
};

export default connect(
    () => ({}),
    mapDispatchToProps
)(ErrorSuccessContainer);
